const INAPP_UPI_PAYMENT_METHOD_PREFIX = "pm_inapp_upi";
const INAPP_UPI_ONBOARDING_PREFIX = "pm_inapp_upi_onboarding";
const NEW_INAPP_UPI_PAYMENT_METHOD_PREFIX = "pm_new_app_upi";

export const INAPP_UPI_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_name`,
    BALANCE: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_bal`,
    PAYMENT_AMOUNT: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_amount`,
    DISABLE_MESSAGE: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_disable_msg`,
    TICK: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_tick`,
    PAY_BUTTON: `${INAPP_UPI_PAYMENT_METHOD_PREFIX}_pay_btn`,
};

export const NEW_INAPP_UPI_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${NEW_INAPP_UPI_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${NEW_INAPP_UPI_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${NEW_INAPP_UPI_PAYMENT_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${NEW_INAPP_UPI_PAYMENT_METHOD_PREFIX}_disable_msg`,
};

export const INAPP_UPI_ONBOARDING_PM_TEST_IDS = {
    CONTAINER: `${INAPP_UPI_ONBOARDING_PREFIX}_container`,
    ICON: `${INAPP_UPI_ONBOARDING_PREFIX}_icon`,
    NAME: `${INAPP_UPI_ONBOARDING_PREFIX}_name`,
    DISABLE_MESSAGE: `${INAPP_UPI_ONBOARDING_PREFIX}_disable_msg`,
    TICK: `${INAPP_UPI_ONBOARDING_PREFIX}_tick`,
    PAY_BUTTON: `${INAPP_UPI_ONBOARDING_PREFIX}_pay_btn`,
};
